import { useState } from "react";
import { hotList, categories } from "@/mocks/news";

export default function Hero() {
  const [activeCat, setActiveCat] = useState("all");
  const selected = categories.find((c) => c.id === activeCat);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const displayHot = hotList.slice(0, 6);

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* 背景装饰 */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/70 blur-3xl" />
        <div className="absolute -left-20 top-40 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 h-56 w-56 rounded-full bg-secondary-100/80 blur-2xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 pb-12 pt-10 md:px-6 md:pb-16 md:pt-14">
        {/* 头部品牌区 */}
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12">
          <div className="animate-floatUp">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-semibold text-accent-800">
              <i className="ri-sparkling-2-fill text-sm" />
              今日焦点 · 每日更新
            </span>
            <h1 className="mt-5 font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl">
              吃瓜51
              <span className="mt-1 block bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">
                今日新瓜速递
              </span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
              聚合全网热门事件与新鲜爆料，娱乐八卦、社会热点、圈内动态一网打尽。
              每天打开吃瓜51，快速掌握今日焦点话题，满足你的好奇心与求知欲。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={() => scrollTo("feed")}
                className="group flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-base font-semibold text-background-50 transition-all hover:bg-primary-600 active:scale-95"
              >
                <i className="ri-flashlight-fill transition-transform group-hover:-rotate-12" />
                开始吃瓜
              </button>
              <button
                type="button"
                onClick={() => scrollTo("hot")}
                className="group flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-300 bg-background-50 px-6 py-3 text-base font-semibold text-foreground-800 transition-all hover:border-secondary-300 hover:bg-secondary-100 active:scale-95"
              >
                <i className="ri-fire-line text-primary-500 transition-transform group-hover:scale-110" />
                查看今日热榜
              </button>
            </div>

            <dl className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-4">
              <div>
                <dt className="text-xs text-foreground-600">日更新热讯</dt>
                <dd className="mt-1 flex items-center gap-1.5 font-heading text-2xl font-bold text-foreground-950">
                  <i className="ri-restart-line text-primary-500" />全天滚动
                </dd>
              </div>
              <div className="hidden h-9 w-px bg-background-300 sm:block" />
              <div>
                <dt className="text-xs text-foreground-600">覆盖栏目</dt>
                <dd className="mt-1 flex items-center gap-1.5 font-heading text-2xl font-bold text-foreground-950">
                  <i className="ri-grid-fill text-primary-500" />6 大板块
                </dd>
              </div>
              <div className="hidden h-9 w-px bg-background-300 sm:block" />
              <div>
                <dt className="text-xs text-foreground-600">更新时效</dt>
                <dd className="mt-1 flex items-center gap-1.5 font-heading text-2xl font-bold text-foreground-950">
                  <i className="ri-time-fill text-primary-500" />分钟级
                </dd>
              </div>
            </dl>
          </div>

          {/* 今日热榜预览 */}
          <div className="animate-floatUp rounded-2xl border border-background-200 bg-background-50/90 p-4 shadow-card backdrop-blur md:p-6" style={{ animationDelay: ".1s" }}>
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-fill text-primary-500" />
                今日热榜 TOP6
              </h2>
              <button
                type="button"
                onClick={() => scrollTo("hot")}
                className="flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700"
              >
                查看全部
                <i className="ri-arrow-right-line" />
              </button>
            </div>

            <ol className="mt-4 space-y-2.5">
              {displayHot.map((item, i) => {
                const top = i < 3;
                return (
                  <li key={item.rank}>
                    <button
                      type="button"
                      onClick={() => scrollTo("feed")}
                      className="group flex w-full items-center gap-3 rounded-xl px-2 py-2 text-left transition-colors hover:bg-secondary-100"
                    >
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-bold ${
                          top
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-200 text-foreground-700"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-foreground-950">
                        {item.title}
                      </span>
                      <span
                        className={`hidden shrink-0 text-xs sm:flex ${
                          item.trend > 0
                            ? "text-primary-500"
                            : item.trend < 0
                              ? "text-secondary-600"
                              : "text-accent-600"
                        }`}
                      >
                        <i
                          className={
                            item.trend === 0
                              ? "ri-arrow-right-up-line"
                              : item.trend > 0
                                ? "ri-arrow-up-line"
                                : "ri-arrow-down-line"
                          }
                        />
                        {Math.abs(item.trend) > 0 ? Math.abs(item.trend) : ""}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>

        {/* 分类速览 */}
        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {categories
            .filter((c) => c.id !== "all")
            .map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => setActiveCat(c.id)}
                className={`group flex flex-col items-start gap-2 rounded-xl border p-4 text-left transition-all ${
                  activeCat === c.id
                    ? "border-primary-300 bg-primary-50"
                    : "border-background-200 bg-background-50 hover:border-secondary-300 hover:bg-secondary-50"
                }`}
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-lg`} />
                </span>
                <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
                <span className="text-xs text-foreground-600">{c.desc}</span>
              </button>
            ))}
        </div>
        {activeCat !== "all" && selected && (
          <p className="mt-3 flex items-center gap-2 text-sm text-foreground-700">
            <i className="ri-focus-3-line text-primary-500" />
            已聚焦“{selected.name}”板块，下方资讯流将随之切换。
          </p>
        )}
      </div>
    </section>
  );
}